import { Box, Button, IconButton, Stack, Tooltip, Typography } from '@mui/material'
import {
  Circle, Close,
  CurrencyExchange,
  MoneyOutlined,
  PaidOutlined,
  Receipt,
  Visibility,
  VisibilityOff
} from '@mui/icons-material'
import { useEffect, useRef, useState, useContext} from 'react'
import { getCondoId } from '../../services/Main/AuthStorage'
import { api } from '../../services/Main/Api'
import Menu from '@mui/material/Menu'
import Context from '../../contexts/Context'
import SimpleTypography from "../Shared/SimpleTypography";

const BalanceBar = ({ req, color='secondary' }) => {
  const ref = useRef(null)
  const {condoIdLogin} = useContext(Context)
  const [open, setOpen] = useState(false)
  const [show, setShow] = useState(false)
  const [error, setError] = useState(null)
  const [data, setData] = useState(null)
  const [accData, setAccData] = useState(null)

  useEffect(() => {
    const condo = getCondoId()
    if (req && condo) {
    api.get(`fitbank/balance/${condoIdLogin ?? condo}/`)
      .then((response) => {
        setData(response.data)
      }).catch((error) => {
      console.log(error.response.data)
      setError(error.response.data)
      })
    }
  }, [req])

  useEffect(function accountData(){
    if(req && getCondoId()){
      api.get(`fitbank/${getCondoId()}/`)
        .then(response => {
          setAccData({
            bank: {
              name: 'Fitbank',
              code: response.data.spb_bank,
            },
            bank_branch: response.data.spb_bank_branch,
            bank_account: `${response.data.spb_bank_account} - ${response.data.spb_bank_account_digit}`,
            pix_key_company: response.data.pix_key_company,
          })
        })
        .catch(error => {
          console.log(error)
        })
    }
  }, [req])

  const formatter = new Intl.NumberFormat('pt-BR', {
    style: 'currency', currency: 'BRL',
  })


  return (
    <>
      <IconButton
        ref={ref}
        onClick={() => setOpen(true)}
        aria-controls={open ? 'account-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        color="primary"
      >
        <PaidOutlined />
      </IconButton>
      <Menu
        open={open}
        anchorEl={ref.current}
        onClose={() => setOpen(false)}
        PaperProps={{
          elevation: 0,
          sx: {
            overflow: 'visible',
            filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
            mt: 1.5,
            '& .MuiAvatar-root': {
              width: 32,
              height: 32,
              ml: -0.5,
              mr: 1,
            },
            '&:before': {
              content: '""',
              display: 'block',
              position: 'absolute',
              top: 0,
              right: 14,
              width: 10,
              height: 10,
              bgcolor: 'background.paper',
              transform: 'translateY(-50%) rotate(45deg)',
              zIndex: 0,
            },
          },
        }}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      >
        <Box sx={{ p: 2, maxWidth: 650, minWidth: 420, width: '100%' }}>
          <SimpleTypography
            label={'Banco'}
            labelStyles={{ fontWeight: 'bold'}}
            isLoading={!accData}
            block={false}
            boxStyles={{ mb: '1rem'}}
            directValue={
              accData?.bank ? (
                <Tooltip title="Copiar banco" arrow>
        <span
          style={{
            cursor: 'pointer',
            textDecoration: 'none', // Sem sublinhado por padrão
          }}
          onClick={() => navigator.clipboard.writeText(accData.bank.code)}
          onMouseEnter={(e) => {
            e.currentTarget.style.textDecoration = 'underline'; // Sublinha no hover
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.textDecoration = 'none'; // Remove sublinhado quando sai do hover
          }}
        >
          {accData.bank.name} - {accData.bank.code}
        </span>
                </Tooltip>
              ) : (
                <Close sx={{ color: 'error.main' }} />
              )
            }
          />

          <SimpleTypography
            label={'Agência'}
            labelStyles={{ fontWeight: 'bold'}}
            isLoading={!accData}
            block={false}
            boxStyles={{ mb: '1rem'}}
            directValue={
              accData?.bank_branch ? (
                <Tooltip title="Copiar agência" arrow>
        <span
          style={{
            cursor: 'pointer',
            textDecoration: 'none',
          }}
          onClick={() => navigator.clipboard.writeText(accData.bank_branch)}
          onMouseEnter={(e) => {
            e.currentTarget.style.textDecoration = 'underline';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.textDecoration = 'none';
          }}
        >
          {accData.bank_branch}
        </span>
                </Tooltip>
              ) : (
                <Close sx={{ color: 'error.main' }} />
              )
            }
          />

          <SimpleTypography
            label={'Conta'}
            labelStyles={{ fontWeight: 'bold'}}
            isLoading={!accData}
            block={false}
            boxStyles={{ mb: '1rem'}}
            directValue={
              accData?.bank_account ? (
                <Tooltip title="Copiar conta" arrow>
        <span
          style={{
            cursor: 'pointer',
            textDecoration: 'none',
          }}
          onClick={() => navigator.clipboard.writeText(accData.bank_account)}
          onMouseEnter={(e) => {
            e.currentTarget.style.textDecoration = 'underline';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.textDecoration = 'none';
          }}
        >
          {accData.bank_account}
        </span>
                </Tooltip>
              ) : (
                <Close sx={{ color: 'error.main' }} />
              )
            }
          />

          <SimpleTypography
            label={'Chave Pix'}
            labelStyles={{ fontWeight: 'bold'}}
            isLoading={!accData}
            block={false}
            boxStyles={{ mb: '1rem'}}
            directValue={
              accData?.pix_key_company ? (
                <Tooltip title="Copiar chave Pix" arrow>
        <span
          style={{
            cursor: 'pointer',
            textDecoration: 'none',
          }}
          onClick={() => navigator.clipboard.writeText(accData.pix_key_company)}
          onMouseEnter={(e) => {
            e.currentTarget.style.textDecoration = 'underline';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.textDecoration = 'none';
          }}
        >
          {accData.pix_key_company}
        </span>
                </Tooltip>
              ) : (
                <Close sx={{ color: 'error.main' }} />
              )
            }
          />
          <Box
            display={'flex'}
            alignItems={'center'}
            height={16}

          >

            <Typography
              display={'flex'}
              alignItems={'center'}
              fontWeight={'bold'}

            >
              {'Saldo'}
              <IconButton
                disabled={!!error}
                onClick={() => setShow(prev => !prev)}
              >
                {show
                  ? <VisibilityOff sx={{ fontSize: 20, color: 'primary.main' }}/>
                  : <Visibility sx={{ fontSize: 20 }}/>
                }
              </IconButton>
            </Typography>
            <Box
              component={'div'}
              align="center"
              sx={{
                  // p: 1,
                  ml: 1,
                  fontWeight: 'bold',
                  // bgcolor: 'neutral.main',
                  // borderRadius: '.5rem'
              }}
              color={'secondary'}
              flexGrow={1}
            >
              {!show ?
                <Box textAlign={'right'}>
                  <Circle sx={{ fontSize: 8, color: 'secondary.main', mr: 0.5 }}/>
                  <Circle sx={{ fontSize: 8, color: 'secondary.main', mr: 0.5 }}/>
                  <Circle sx={{ fontSize: 8, color: 'secondary.main', mr: 0.5 }}/>
                  <Circle sx={{ fontSize: 8, color: 'secondary.main', mr: 0.5 }}/>
                  <Circle sx={{ fontSize: 8, color: 'secondary.main', mr: 0.5 }}/>
                  <Circle sx={{ fontSize: 8, color: 'secondary.main' }}/>
                </Box>
                :
                <Typography
                  textAlign={'right'}
                  color={'secondary'}
                  // fontWeight={'bold'}
                >
                  {formatter.format(data?.balance)}
                </Typography>
              }
            </Box>
          </Box>
          <Stack mt={3}>
            <Button
              variant={'contained'}
              disabled={!!error}
              href="/transferencia"
              // startIcon={<CurrencyExchange/>}
              sx={{mb: 2}}
            >
              {'Transferir'}
            </Button>
            <Button
              variant={'contained'}
              disabled={!!error}
              href="/pagamento/list"
              // startIcon={<CurrencyExchange/>}
              sx={{mb: 2}}
            >
              {'Pagar'}
            </Button>
            <Button
              variant={'outlined'}

              // startIcon={<Receipt/>}
              href="/extrato">
              {'Ver Extrato'}
            </Button>
          </Stack>
        </Box>
      </Menu>
    </>
  )
}

export default BalanceBar
